export default {
  首页: "ön Sayfa",
  资产: "varlıklar",
  币币: "Para birimi",
  快捷买币: "Hızlı bir şekilde jeton satın alın",
  "支持多种方式购买，购买更简单":
    "Satın almanın birden fazla yolunu destekleyin, satın alması daha kolay",
  语言设置: "dil ayarları",
  确认恢复: "kurtarmayı onayla",
  "输入邮箱，方便我们联系您":
    "Sizinle iletişim kurabilmemiz için e-postanızı girin",
  划转: "Aktar",
  行情: "alıntılar",
  "24H成交": "24 saat anlaşma",
  累计收益: "kümülatif gelir",
  充值时间: "şarj süresi",
  到期时间: "Son kullanma tarihi",
  数量: "miktar",
  操作: "işletmek",
  资产信息: "varlık bilgisi",
  复制地址: "Adresi kopyala",
  链名称: "zincir adı",
  充值地址: "Şarj adresi",
  收款地址: "alıcı adresi",
  账单: "fatura",
  提现金额: "Para Çekme Miktarı",
  接收地址: "alıcı adresi",
  交易密码: "İşlem Şifresi",
  提现全部: "Hepsini geri çek",
  保存图片: "resmi Kaydet",
  输入您的交易密码: "işlem şifrenizi girin",
  确定: "Elbette",
  地址: "adres",
  注册时间: "Kayıt zamanı",
  取消: "İptal",
  是否划转: "aktarılıp aktarılmayacağı",
  登录: "Giriş yapmak",
  我的地址: "benim adresim",
  登录密码和交易密码: "Giriş şifresi ve işlem şifresi",
  注册: "Kayıt ol",
  密码: "şifre",
  设置密码: "şifreyi belirle",
  重复密码: "Şifreyi tekrar girin",
  新密码: "Yeni Şifre",
  确认新密码: "Yeni şifreyi onaylayın",
  充值: "şarj etmek",
  充值货币: "Şarj para birimi",
  合约账户充值: "Sözleşme hesabı yeniden yükleme",
  账户充值: "Hesap şarjı",
  其他: "başka",
  我的邀请码: "davet kodum",
  提现: "Çekil",
  客服: "müşteri servisi",
  持有详情: "tutma detayları",
  请输入内容: "Lütfen içeriği girin",
  邀请好友来领取奖励: "Arkadaşlarınızı ödül talep etmeye davet edin",
  复制链接: "Bağlantıyı kopyala",
  重复设置新的密码: "Yeni bir parola ayarlamak için tekrarlayın",
  保存: "kaydetmek",
  我的: "benim",
  "邮箱/手机号": "E-posta/Cep Numarası",
  备注: "açıklama",
  地址管理: "adres yönetimi",
  我的团队: "benim takımım",
  联系我们: "Bize Ulaşın",
  竭诚为您服务: "Saygılarımla hizmetinizdeyim",
  提取收益: "Gelirleri çekme",
  带给我的收益: "bana faydaları",
  添加: "a ekle",
  名称: "isim",
  添加地址: "adres Ekle",
  修改地址: "Adres değiştir",
  可提现: "Çekmeceli",
  安全中心: "Güvenlik Merkezi",
  收益划转: "hasılat transferi",
  通知中心: "Bildirim Merkezi",
  "累计收益:": "Kümülatif gelir:",
  注册用户: "kayıtlı kullanıcı",
  奖励规则: "ödül kuralları",
  帮助反馈: "yardım geri bildirimi",
  邀请好友: "arkadaşları davet etmek",
  恢复身份: "kimliği geri yükle",
  选择语言: "Bir dil seçin",
  设置新的密码: "yeni bir şifre belirle",
  暂无活动: "henüz etkinlik yok",
  "月增长量(+)": "Aylık büyüme (+)",
  可提取: "çıkarılabilir",
  反馈类型: "geri bildirim türü",
  赠送: "hediye",
  已经复制: "zaten kopyalandı",
  保存成功: "Başarıyla kaydedildi",
  划转成功: "Aktarım başarılı",
  过期: "Süresi doldu",
  提交成功: "Başarıyla gönderildi",
  "服务器繁忙，稍后在试": "Sunucu meşgul, daha sonra deneyin",
  全部: "tüm",
  一级: "Seviye bir",
  二级: "İkincil",
  三级: "Üçüncü seviye",
  级: "sınıf",
  删除成功: "başarıyla silindi",
  选择地址: "adres seç",
  不再提醒: "hatırlatma yok",
  "最小充值金额：": "Minimum şarj miktarı:",
  选择币种: "Para birimini seçin",
  输入投资金额: "Yatırım tutarını girin",
  输入账户密码: "Hesap parolasını girin",
  投资: "yatırım",
  订单编号: "sipariş numarası",
  投资周期: "yatırım döngüsü",
  投资资金: "yatırım fonları",
  投资时间: "yatırım zamanı",
  状态: "durum",
  投资中: "yatırım",
  已到期: "süresi dolmuş olmak",
  暂无数据: "Veri yok",
  转入: "içeriye transfer et",
  邮箱: "Posta",
  请输入邮箱: "lütfen e-postanızı girin",
  请输入格式正确的邮箱: "Lütfen doğru biçimde bir e-posta adresi girin",
  请输入验证码: "lütfen doğrulama kodunu girin",
  获取验证码: "doğrulama kodu al",
  请输入邀请码: "Lütfen davet kodunu girin",
  今天: "bugün",
  昨天: "dün",
  最近七天: "son yedi gün",
  邀请: "Davet et",
  购买数量: "Satın alma miktarı",
  产品详情: "Ürün Detayları",
  币种: "Para birimi",
  利息币种: "Faiz Para Birimi",
  理财类型: "Mali yönetim türü",
  产品费率: "ürün oranı",
  进行中: "işleme",
  每天: "Her gün",
  请输入搜索关键词: "Lütfen arama anahtar kelimesini girin",
  通知: "Fark etme",
  查看更多: "daha fazla gör",
  理财宝: "Para hazinesi",
  周期: "Çevrim",
  年利率: "yıllık faiz oranı",
  更多产品: "daha fazla ürün",
  灵活存取: "esnek erişim",
  稳定收益: "sabit gelir",
  合约指南: "Sözleşme Rehberi",
  资金划转出: "para transferi",
  矿池收益: "Madencilik havuzu geliri",
  提现手续费: "Para çekme ücreti",
  冻结资金: "fonları dondurmak",
  解冻资金: "fonları çözmek",
  闪兑支出: "Anında ödeme",
  闪兑收入: "Anında gelir",
  闪兑手续费: "Anında ücret",
  合约支出: "sözleşme ödemesi",
  合约收入: "sözleşme geliri",
  输入的金额不可大于可用金额: "Girilen miktar mevcut miktardan fazla olamaz",
  全部兑换成功: "Hepsi başarıyla değiştirildi",
  返回: "dönüş",
  查看历史: "geçmişi görüntüle",
  闪兑历史: "Flaş Geçmişi",
  支付: "ödemek",
  获取: "Elde etmek",
  时间: "zaman",
  手续费: "Hizmet bedeli",
  折扣: "İndirim",
  价格: "fiyat",
  逐仓: "Yalıtılmış",
  全仓: "Geçmek",
  市价委托: "Market siparişi",
  限价委托: "limit emri",
  请输入本金: "Lütfen müdürü girin",
  请输入价格: "Lütfen bir fiyat girin",
  "可做空/做多": "Kısa/uzun gidebilir",
  设置止盈止损: "TP/SL",
  止盈价: "Kar Fiyatı Al",
  止损价: "Durdurma fiyatı",
  成本: "maliyet",
  做多: "daha fazla yap",
  做空: "kısa",
  仓位信息: "Konum bilgisi",
  一键平仓: "Hepsini kapat",
  永续: "sürdürülebilir",
  浮动盈亏: "Değişken kar ve zarar",
  平仓: "bir pozisyonu kapat",
  反向开仓: "ters açılış",
  一键撤销: "Tek tıkla geri alma",
  倍杠杆: "çift ​​kaldıraç",
  执行价格: "yürütme fiyatı",
  委托数量: "Sipariş Miktarı",
  保证金: "kenar boşluğu",
  成交价: "son fiyat",
  创建时间: "yaratma zamanı",
  撤销: "geri çekmek",
  合约市场: "sözleşme piyasası",
  交易方向: "işlem yönü",
  委托价格: "komisyon fiyatı",
  委托金额: "emanet edilen miktar",
  资金费率: "fonlama oranı",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Uzun ve kısa tüccarlar tarafından ödenen, her 8 saatte bir hesaplanan yinelenen bir ücret.",
  "资金费率为正，多方向空方支付资金费用。":
    "Fonlama oranı pozitiftir ve boğa tarafı fonlama ücretini kısa tarafa öder.",
  "资金费率为负，空方向多方支付资金费用。":
    "Fonlama oranı negatiftir ve kısa taraf uzun tarafa fonlama ücretini öder.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Bir ters pozisyon açacağınızdan emin misiniz? Ters bir pozisyon açmak, satın almak için cari dönemin zıt pozisyonunu kullanacaktır.",
  "仓位止盈/止损": "Pozisyon Kar Al/Zararı Durdur",
  合约名称: "sözleşme adı",
  开仓价格: "açılış fiyatı",
  指数价格: "endeks fiyatı",
  止盈设置: "Kar Ayarı Al",
  请输入止盈价: "Lütfen kar alma fiyatını giriniz",
  "当指数价格触达*时，将会触发委托平仓":
    "Endeks fiyatı {0} değerine ulaştığında, pozisyonu kapatmak için emir tetiklenecektir.",
  预计盈亏: "Tahmini kar ve zarar",
  当前仓位: "şu anki pozisyon",
  平仓金额: "kapanış tutarı",
  仓位模式: "Konum modu",
  全仓模式: "Çapraz Marj Modu",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "Sözleşme hesabındaki tüm kullanılabilir fonlar, kullanılabilir teminat olarak kabul edilir.Pozisyon kaybı hesap bakiyesini aştığında, pozisyon tasfiye edilecek ve tüm teminat ve pozisyonlar kaybedilecektir.Lütfen dikkat",
  逐仓模式: "İzole Marj Modu",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "Sözleşme hesabındaki belirli bir miktar teminat, pozisyona tahsis edilecektir. Teminat kaybı, sürdürme teminatı seviyesinden düşükse, pozisyon tasfiye edilir. İzole Marj modunda, bu pozisyon için marjı artırabilir ve azaltabilirsiniz.",
  "是否撤销？": "İptal edildi mi?",
  "是否一键撤销？": "Tek tuşla geri almak mümkün mü?",
  "是否一键平仓？": "Tek tıkla pozisyon kapatmak mümkün mü?",
  持仓保证金: "kenar boşluğu",
  风险率: "risk oranı",
  未实现盈亏: "Hayır P&L",
  可用保证金: "Mevcut marj",
  净值: "net değer",
  账户余额: "Hesap bakiyesi",
  合约计算器: "Sözleşme Hesaplayıcı",
  交易记录: "İşlem kaydı",
  "*倍杠杆": "{num}Çift kaldıraç",
  "平仓盈亏：": "Kapanış kar ve zararı:",
  时间筛选: "zaman filtresi",
  仓位类型: "Pozisyon Türü",
  订单状态: "Sipariş durumu",
  订单类型: "Sipariş türü",
  平仓价格: "Kapanış fiyatı",
  持仓数量: "Pozisyon sayısı",
  "手续费(%)": "Ücret (%)",
  平仓时间: "Kapanış saati",
  平仓类型: "Kapanış tipi",
  手动平仓: "Pozisyonları manuel olarak kapatın",
  强制平仓: "zorla tasfiye",
  近1天: "yaklaşık 1 gün",
  近7天: "son 7 gün",
  近30天: "son 30 gün",
  近180天: "yaklaşık 180 gün",
  持仓: "durum",
  已取消: "İptal edildi",
  分时: "zaman paylaşımı",
  "24H额(USDT)": "24 Saat Tutarı (USDT)",
  "24H低": "24 saat düşük",
  "24H量(BTC)": "24H tutarı (BTC)",
  "24H高": "24 saat yüksek",
  "10秒": "10 saniye",
  "30秒": "30 saniye",
  "1分": "1 puan",
  "3分": "3 puan",
  "5分": "5 puan",
  "30分": "30 puan",
  "1小时": "1 saat",
  "4小时": "4 saat",
  "8小时": "8 saat",
  "1天": "1 gün",
  "1周": "1 hafta",
  "1月": "Ocak",
  单向持仓: "Tek yönlü konum",
  杠杆: "kaldıraç",
  仓位: "durum",
  计算结果: "Hesaplama sonuçları",
  盈亏: "kar ve zarar",
  收益率: "getiri oranı",
  计算结果仅供参考: "Hesaplama sonuçları sadece referans içindir",
  成交后仓位大小: "İşlem sonrası pozisyon büyüklüğü",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Hesaplama sonuçları yalnızca referans amaçlıdır, oran farklılıkları nedeniyle gerçek sonuçlar değişebilir",
  目标价格: "hedef fiyat",
  开始计算: "hesaplamaya başla",
  强平价格: "tasfiye fiyatı",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Yeniden yüklemeden önce lütfen yeniden yükleme zincirinin adını dikkatlice kontrol edin.Yanlış yükleme durumunda varlıklar geri alınamaz.{0}Minimum yeniden yükleme miktarı {1}'dır; bu tutarın altındaysa platform hesabı onaylamayacaktır.Lütfen yapın {2} dışındaki varlıkları bu adrese yüklemeyin, aksi takdirde varlıkları geri alamazsınız, lütfen doğrudan kitle fonlaması veya ICO adresine nakit çekmeyin ve Ping, paraları sizin adınıza dağıtmayacaktır.",
  "最小输入*": "Minimum giriş{0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "Minimum para çekme tutarı {0}'dır ve para çekme ücreti, para çekme tutarınızdan düşülecektir. Lütfen madeni para çekmeden önce alıcı adresi onaylayın ve kontrol edin ve {1} parasını {2} dışında bir adrese çekmeyin, aksi takdirde varlıklar geri alınmayacaktır. Lütfen doğrudan kitle fonlaması veya ICO adresine nakit çekmeyin, platform belirteç ihracını işlemeyecektir.",
  退出登录: "oturumu Kapat",
  加仓: "pozisyonu arttır",
  新增仓位: "Yeni pozisyon",
  输入加仓金额: "Artış miktarını girin",
  "当前可用:": "Şu anda mevcut:",
  资产账单: "varlık faturası",
  保存二维码: "QR kodunu kaydedin",
  温馨提示: "nazik ipuçları",
  "请注意：您当前使用的网络": "Not: mevcut ağınız",
  输入提现地址: "Para çekme adresini girin",
  "可用金额：": "Mevcut miktar:",
  输入资产密码: "Varlık parolasını girin",
  可用手续费: "Mevcut Ücretler",
  "折扣%": "İndirim%",
  实扣手续费: "Gerçek kesinti ücreti",
  实际到账: "gerçek hesap",
  未设置资产密码: "Varlık şifresi ayarlanmadı",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "Varlıklarınızın güvenliği için lütfen para çekmeden önce varlık şifresini ayarlayın.",
  热榜: "sıcak liste",
  涨幅榜: "Yükselmek",
  跌幅榜: "Beceriksiz",
  成交额榜: "Devir",
  关于我们: "Hakkımızda",
  登录密码: "giriş şifresi",
  设置: "kurmak",
  资产密码: "Varlık parolası",
  修改登录密码: "Giriş şifresini değiştir",
  原密码: "eski Şifre",
  请输入新密码: "Lütfen yeni bir şifre girin",
  请输入原密码: "Lütfen orijinal şifreyi girin",
  确认密码: "Şifreyi Onayla",
  确定修改: "değiştirmek için tamam",
  修改资产密码: "Varlık şifresini değiştir",
  验证码: "doğrulama kodu",
  资产密码使用提示: "Varlık parolalarını kullanmayla ilgili ipuçları",
  "资产密码用于转移、提取资产和交易。":
    "Varlık şifreleri varlıkları aktarmak, çekmek ve ticaret yapmak için kullanılır.",
  "创建与登录密码不同的资产密码。":
    "Oturum açma parolasından farklı bir varlık parolası oluşturun.",
  "定期更改您的资产密码。": "Varlık parolalarınızı düzenli olarak değiştirin.",
  提币历史: "Para çekme geçmişi",
  "金额/余额": "Tutar/Bakiye",
  "手续费/折扣": "Ücret/İndirim",
  自选: "isteğe bağlı",
  现货: "Spot ürünler",
  市价: "Market fiyatı",
  止损设置: "Kaybı durdur ayarı",
  合约K线图: "Sözleşme mum grafiği",
  "24H量": "24 saat hacim",
  "24H额": "24H miktarı",
  合作指南: "İşbirliği Rehberi",
  盈亏计算: "kar ve zarar hesaplama",
  当前可用: "Şu anda mevcut",
  请输入加仓金额: "Lütfen artış miktarını giriniz",
  请重新输入加仓金额: "Lütfen artış miktarını tekrar girin",
  平仓数量: "Kapanış Miktarı",
  欢迎登录: "giriş lütfen",
  "忘记密码?": "Parolanızı mı unuttunuz?",
  "还没有账号？": "Henüz bir hesabınız yok mu?",
  立即注册: "Şimdi kayıt ol",
  繁體中文: "Geleneksel çince",
  找回密码: "Parola Al",
  下一步: "Sonraki adım",
  注册账户: "hesap kaydı",
  "请输入邀请码(选填)": "Lütfen davet kodunu girin (isteğe bağlı)",
  谢邀豪礼: "Davetiniz için teşekkür ederim",
  "24小时邀请好友排名": "24 saat arkadaş davet sıralaması",
  "*人": "{0}insanlar",
  "差*人": "{0}Zavallı kişi",
  "已超过10万人，每月轻松赚钱":
    "100.000'den fazla kişi, her ay para kazanması kolay",
  最高: "En yüksek",
  邀请链接: "davet bağlantısı",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "Platform, platformdaki arkadaşlar tarafından oluşturulan işlem ücretlerini sizinle paylaşır (spot, sözleşme, kaldıraç, flash değişimi)",
  平台和您一起分享手续费: "Platform işlem ücretini sizinle paylaşır",
  "*级": "{0}sınıf",
  规则: "kural",
  我的好友: "iyi arkadaşım",
  好友详情: "arkadaş detayları",
  获得好友佣金方案: "Arkadaş Edin Komisyon Programı",
  我的等级: "notum",
  我的邀请数据: "davet verilerim",
  当前等级: "mevcut seviye",
  平台奖励您: "Platform sizi ödüllendiriyor",
  最高可获取平台奖励: "Elde edilebilecek en yüksek platform ödülleri",
  邀请规则: "davet kuralları",
  "邀请*级有效好友": "{0} düzeyinde geçerli arkadaşlarınızı davet edin",
  好友等级: "arkadaş seviyesi",
  人: "insanlar",
  奖金派送: "ikramiye teslimatı",
  平台奖励: "platform ödülleri",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "Nihai yorumlama hakkı platforma aittir.Platform ödüllerini elde etmek için anormallikler tespit edilirse, tüm ödüller düşülecek ve hesap dondurulacaktır.Varlık kaybı geri alınmayacaktır.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Hesabınız geçerli bir hesap olmalıdır ve platform, geçerli hesap koşulunun (herhangi bir para biriminde hesap yeniden yüklemesi) minimum {0} USDT değeri olduğunu belirler.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "Davet ettiğiniz arkadaş geçerli bir ast olmalıdır ve platform, geçerli astın minimum {0} USDT (herhangi bir para biriminden hesap yeniden yüklemesi) değeri olduğunu belirler.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Davet edenin ve davet edilenin hesapları aynı IP'ye ait olamaz.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "VIP düzeyi, davet ettiğiniz {0} düzeyindeki arkadaş sayısına göre değerlendirilir.",
  佣金成分: "komisyon bileşeni",
  收益统计: "gelir istatistikleri",
  昨日收益: "dünkü kazanç",
  月收益: "aylık gelir",
  获取收益: "gelir elde etmek",
  "总收益：": "Toplam gelir:",
  "*级好友": "{0} seviye arkadaş",
  理财购买: "finansal satın alma",
  期限: "dönem",
  可用金额: "Mevcut miktar",
  预估收益: "Tahmini gelir",
  申购上限: "Abonelik sınırı",
  项目剩余: "Kalan öğe",
  "买入后预计*(SGT)开始计算收益。":
    "Satın aldıktan sonra kazançları hesaplamaya başlaması{0} (SGT) bekleniyor.",
  计息日: "Faiz tarihi",
  申购日: "abonelik tarihi",
  到账日: "Varış tarihi",
  到期自动续投: "Süre dolduğunda otomatik yenileme",
  申购: "satın alma",
  搜索理财项目: "Finansal projeler ara",
  超高年化随心选: "Ultra yüksek yıllıklaştırma, istediğiniz gibi seçin",
  "自由选择理财币种，稳定超额收益":
    "Servet yönetimi para birimini özgürce seçme, istikrarlı fazla getiriler",
  理财总资产: "Toplam varlık yönetimi varlıkları",
  累计收益: "kümülatif gelir",
  申购数量: "Abonelik miktarı",
  立即购买: "Şimdi al",
  年化收益率: "Yıllık getiri oranı",
  理财订单: "mali düzen",
  持有: "tutmak",
  申购份额: "Abonelik payı",
  到账日期: "Varış tarihi",
  申购成功: "Abonelik başarılı",
  到期: "olgunluk",
  是否选择做多: "daha fazlasını yapmayı seçer misin",
  "可用余额为0 不能操作": "Kullanılabilir bakiye 0'dır ve çalıştırılamaz",
  福利中心: "refah merkezi",
  奖励记录: "ödül kaydı",
  我获取到的奖励: "aldığım ödüller",
  总价值: "toplam değer",
  新手任务: "acemi görevi",
  身份认证: "kimlik doğrulama",
  身份验证: "kimlik doğrulama",
  去验证: "doğrulamak için",
  审核中: "inceleme altında",
  已验证: "doğrulandı",
  认证失败: "Kimlik doğrulama başarısız oldu",
  基础认证: "Temel Sertifikasyon",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Kimlik doğrulama bilgileri doğrulandıktan sonra değiştirilemeyeceğini lütfen unutmayın, bu nedenle doğru bilgileri girdiğinizden emin olun.",
  "国家/地区": "ülke / bölge",
  请选择: "lütfen seç",
  证件类型: "sertifika türü",
  证件编码: "Kimlik kodu",
  身份证: "kimlik kartı",
  护照: "pasaport",
  驾驶证: "Ehliyet",
  请输入编码: "Lütfen kodu girin",
  名字: "isim",
  请输入: "girin lütfen",
  中间名: "ikinci ad",
  选填: "isteğe bağlı",
  姓氏: "soyadı",
  中国: "Çin",
  身份上传: "kimlik yükleme",
  上传身份证: "yükleme kimliği",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Yukarıdaki materyallerin JPG/JPEG/PNG formatında yüklenmesi ve fotoğrafların net, eksiksiz ve tekdüze parlaklıkta olduğundan emin olunması gerekir. Ve boyut {0} M'yi geçmez.",
  确定提交: "Gönderimi Onayla",
  去认证: "kimlik doğrulamaya git",
  挑战任务: "meydan okuma görevi",
  注册认证任务: "Kayıt Sertifika Görevi",
  完成注册认证即可领取:
    "Kayıt sertifikasını tamamladıktan sonra alabilirsiniz.",
  领取奖励: "Ödül al",
  新人豪礼: "yeni gelen hediye",
  "参与人数：": "Katılımcı sayısı:",
  条件: "şart",
  入金量: "depozito miktarı",
  完成: "Bitiş",
  任务奖励: "görev ödülleri",
  距任务更新: "görevden güncelleme",
  "条件：": "şart:",
  活动规则: "etkinlik kuralı",
  奖励明细: "Ödül Ayrıntıları",
  已获得: "Elde edilen",
  交易奖励: "işlem ödülü",
  Win奖励: "Ödüller kazanın",
  已领取: "Alınan",
  亏损金额超过: "Kayıp miktarı aşıyor",
  单笔开仓金额超过: "Tek bir pozisyon açma tutarı aşıyor",
  交易量: "Işlem hacmi",
  待完成: "tamamlanacak",
  入金: "Depozito",
  盈利金额超过: "kar tutarı aşıyor",
  开仓金额: "açılış tutarı",
  开仓金: "İlk para yatırma",
  盈利: "kâr",
  亏损: "kayıp",
  领取: "almak",
  未领取: "onaylanmamış",
  待领取: "Toplanacak",
  再交易: "yeniden ticaret",
  即可获得: "elde edilebilir",
  领取成功: "başarı elde etmek",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Tüm aktiviteler, aktivitenin son zamanına göre sayılacaktır, gelir süresi dolduktan sonra geçersiz olacaktır.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Elde edilen gelir bounty hesabınıza dağıtılacaktır ve ihtiyacınıza göre istediğiniz zaman nakit bozdurabilir ve nakit çekebilirsiniz.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. Elde edilen ödül para birimi türü, görev türüne göre verilecektir.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. Nihai yorumlama hakkı platforma aittir.Platformun görev bonusunu tahkim edecek anormal yöntemler tespit edilirse, platform elde ettiğiniz geliri dondurma ve mahsup etme hakkına sahiptir.",
  成长学院: "Büyüme Akademisi",
  区块链: "blok zinciri",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Kripto para birimi için tek noktadan rehberiniz, sizi kripto para birimine giden yola götürüyoruz.",
  "全仓合约定单的全部保证金。":
    "Çapraz marjlı sözleşme emirleri için tam marj.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Hesap bakiyesi + (değişken kâr ve zarar - işlem ücreti - gecelik ücret) = öz sermaye / kullanılan marj * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    'Dalgalanan kar ve zarar "mevcut marjı" doğrudan etkileyecektir. Gerçekleşmemiş kar ve zarar arttığında, mevcut marj artacak ve gerçekleşmemiş kar ve zarar azalacak ve kullanılabilir marj da azalacaktır.',
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Hesap bakiyesi - (kullanılan marj) + (değişken kâr ve zarar - işlem ücreti - gecelik ücret)",
  "注:可继续用于开仓的保证金。":
    "Not: Pozisyon açmak için kullanılmaya devam edilebilecek teminat.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Hesap bakiyesi + (değişken kâr ve zarar - işlem ücreti - gecelik ücret)",
  "注:当前的资金结余。": "NOT: Mevcut fon bakiyesi.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Kullanılamayan bakiyeler dahil olmak üzere sözleşme hesabının tüm bakiyesini ifade eder.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Not: Risk oranı ne kadar yüksekse risk o kadar düşüktür ve risk oranı ne kadar düşükse risk o kadar yüksektir.",
  该功能尚未开发: "Bu özellik henüz geliştirilmemiştir",
  重置密码: "şifreyi yenile",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Lütfen 8-20 karakter girin, harf, sayı ve özel karakter içermelidir",
  修改成功: "Başarıyla değiştirildi",
  输入验证码: "onay kodunu girin",
  输入密码: "şifre girin",
  详情说明: "Detaylar",
  已售罄: "Hepsi satıldı",
  剩余期限: "kalan süre",
  限期: "son tarih",
  闪兑货币选择: "Anında Döviz Seçimi",
  地区选择: "bölge seçimi",
  "搜索国家/地区": "ülke ara",
  "身份信息已提交，将在*小时内审核完成":
    "Kimlik bilgileri gönderildi ve {0} saat içinde incelenecek",
  "选择国家/地区": "ülke seç",
  "止盈价格需高于*": "Kâr alma fiyatının {0} değerinden yüksek olması gerekir",
  "止损价格需低于*":
    "Zararı durdur fiyatının {0} değerinden düşük olması gerekir",
  "止盈价格需低于*": "Kâr alma fiyatı {0} değerinden düşük olmalıdır",
  "止损价格需高于*":
    "Zararı durdur fiyatının {0} değerinden yüksek olması gerekir",
  教程详情: "Eğitim Ayrıntıları",
  请输入止损价: "Lütfen bir durdurma fiyatı girin",
  活期: "akım",
  赎回后立即到账: "Tahliyeden hemen sonra",
  赎回: "kefaret",
  赎回理财: "Mali yönetimi kullanın",
  是否赎回当前的理财订单:
    "Mevcut servet yönetimi emrinin kullanılıp kullanılmayacağı",
  维护: "sürdürmek",
  "系统正在维护中……": "Sistem bakımda...",
  合约: "sözleşme",
  闪电兑换: "Yıldırım değişimi",
  流水挖矿: "Akış madenciliği",
  邀请豪礼: "davet hediyesi",
  计算器: "hesap makinesi",
  最新价: "Son fiyat",
  涨跌幅: "Teklif değişikliği",
  关注币种添加自选: "Para birimini takip edin ve isteğe bağlı ekleyin",
  一键添加自选: "İsteğe bağlı tek tıkla ekleme",
  全标已读: "Tüm etiketler okundu",
  无消息: "haber yok",
  "暂时还没有收到任何消息通知哦!": "Henüz herhangi bir bildirim almadınız!",
  没有更多数据: "daha fazla veri yok",
  闪兑: "Flaş",
  从: "itibaren",
  "可用余额：": "Kalan bakiye:",
  至: "ile",
  预览兑换结果: "Değişim sonucunu önizleyin",
  闪兑规则: "Flash Değişim Kuralları",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "Piyasa flash değişimi değişebilir, lütfen alınan gerçek miktara bakın.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "Döviz kuru üçüncü bir şahıs tarafından belirlenir. Döviz maliyetleri ve piyasa dalgalanmaları nedeniyle, değiştirdiğiniz döviz kuru piyasa döviz kurundan daha yüksek olabilir. Lütfen devam etmeden önce dikkatlice onaylayın.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "Platform, borsadaki değişim maliyetini ödemek için kullanılan her bir havale için yaklaşık {fee}% tutarında bir işlem ücreti alır.",
  确认汇兑: "Değişimi onaylayın",
  您预估得到: "sen tahmin et",
  汇兑: "Değiş tokuş",
  汇兑比例: "Döviz kuru",
  刷新: "yenilemek",
  兑换: "değiş tokuş",
  没有更多了: "daha fazla yok",
  搜索币种: "para birimi ara",
  可用: "mevcut",
  我知道了: "Anlıyorum",
  最新价格: "son fiyat",
  确认: "onaylamak",
  最大: "maksimum",
  "风险率(%)": "Risk oranı (%)",
  持仓: "durum",
  当前委托: "mevcut komisyon",
  合作交易历史记录: "İşbirliği işlem geçmişi",
  重置: "Sıfırla",
  余额: "denge",
  现货账户: "Finansman Hesabı",
  合约账户: "vadeli işlemler",
  WIN账户: "Kazanç",
  赏金账户: "Hediye",
  总资产折合: "Toplam varlık eşdeğeri",
  今日收益: "Bugünün Kazançları",
  充币: "Depozito",
  提币: "Para çekme",
  账户权益: "Hesap Sermayesi",
  "数量/类别": "Miktar/Tip",
  全部币种: "Tüm para birimleri",
  全部类型: "her türlü",
  账单信息: "Fatura bilgileri",
  理财赎回: "Mali itfa",
  购买理财: "para satın al",
  收入: "Gelir",
  支出: "harcama",
  到: "varmak",
  资产划转: "varlık transferi",
  "最少*": "en az*",
  "可用资产：": "Mevcut varlıklar:",
  确认划转: "Aktarımı onayla",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Sadece varlıklar ilgili hesaba aktarıldığında işlem yapılabilir ve hesaplar arası aktarım için herhangi bir işlem ücreti alınmaz.",
  币种账户选择: "Döviz Hesabı Seçimi",
  选择账户: "hesap seç",
  划转详情: "Aktarım ayrıntıları",
  划转明细: "Aktarım ayrıntıları",
  收入账单: "gelir faturası",
  支出账单: "harcama faturası",
  金额: "Tutar",
  总收益: "Toplam gelir",
  佣金: "komisyon",
  用户名: "Kullanıcı adı",
  "已领取：": "Alınan:",
  "未领取：": "kabul edilmemiş:",
  "请选择国家/地区": "lütfen bir ülke seçiniz",
  请上传身份信息: "Lütfen kimlik bilgilerini yükleyin",
  请选择证件类型: "Lütfen bir belge türü seçin",
  请填写证件编码: "Lütfen kimlik numarasını giriniz",
  请填写名字: "Lütfen adı giriniz",
  请填写姓氏: "Lütfen soyadını giriniz",
  单向持仓: "Tek yönlü konum",
  投资金额: "yatırım tutarı",
  天: "gökyüzü",
  请输入手机号: "Lütfen telefon numarasını giriniz",
  搜索: "arama",
  搜索历史: "arama geçmişi",
  热门推荐: "popüler öneri",
  "《Xspace Earn协议》": "《Xspace Kazanma Sözleşmesi》",
  我已了解并同意: "anlıyorum ve katılıyorum",
  协议: "protokol",
  Xspace官方中文交流群: "Xspace resmi Çin iletişim grubu",
  Xspace官方英文交流群: "Xspace resmi İngilizce iletişim grubu",
  预计维护至: "Beklenen bakım",
  更多功能: "Daha fazla özellik",
  下载APP: "İndir uygulaması",
  理财: "finansal Yönetim",
  推荐: "tavsiye etmek",
  Telegram官方中文频道: "Telegram resmi Çin kanalı",
  Telegram官方英文频道: "Telegram Resmi İngilizce Kanalı",
  官方邮箱: "Resmi e-posta",
  客服邮箱: "Müşteri Hizmetleri E-postası",
  上述信息最终解释权归官方所有:
    "Yukarıdaki bilgilerin nihai yorumu yetkiliye aittir.",
  IOS版下载: "IOS sürümü indirme",
  Android版下载: "Android için indir",
  "手续费=买入手续费+资金费率+卖出手续费":
    "İşlem ücreti = Satın alma işlem ücreti + Finansman oranı + Satış işlem ücreti",
  资金划转: "para transferi",
  止盈: "kar almak",
  止损: "kaybı durdurmak",
  自动平仓: "otomatik kapatma",
  委托挂单: "bekleyen emri emanet et",
  买: "satın alma",
  卖: "Satmak",
  "买入/做多": "satın al/uzun",
  "卖出/做空": "satmak/kısa",
  详情: "detaylar",
  浮动涨跌: "yukarı ve aşağı yüzen",
  最小: "en küçük",
  充币数量: "depozito miktarı",
  请输入充币数量: "Lütfen depozito tutarını giriniz",
  支付截图: "Ödeme Ekran Görüntüsü",
  提交: "Sunmak",
  上传驾驶证: "ehliyet yükle",
  上传护照: "pasaport yükle",
  加载中: "Yükleniyor",
  上传成功: "başarıyla yüklendi",
  充值历史: "Şarj geçmişi",
  合约卖出手续费: "Sözleşme satış ücreti",
  合约买入手续费: "Sözleşme satın alma ücreti",
  系统加款: "Sistem para ekle",
  系统减款: "Sistem kesintisi",
  合约资金费率: "Sözleşme fonlama oranı",
  佣金分成: "komisyon payı",
  U本位合约: "U standart sözleşme",
  资产管理: "varlık Yönetimi",
  APP下载: "İndir uygulaması",
  全球领先的数字理财平台:
    "Dünyanın önde gelen dijital servet yönetimi platformu",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Bitcoin ve Ethereum gibi yüzlerce dijital varlığın anında ticaretini yapın",
  "24H涨跌幅": "24 saat yükseliş ve düşüş",
  查看更多行情: "Daha fazla alıntı görüntüle",
  近24小时成交量: "Son 24 saatteki işlem hacmi",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Çeşitli ticaret ihtiyaçlarını karşılamak için yüzlerce döviz ve sözleşme ticaret çifti sağlayın. 200 ülke ve bölgede 20 milyondan fazla kullanıcıya sahip olan platform, dünyanın önde gelen dijital varlık hizmet platformudur.",
  用户国家分布: "Kullanıcı ülke dağılımı",
  用户数: "kullanıcı numarası",
  交易对: "ticaret çifti",
  服务支持: "servis desteği",
  "随时随地，多平台终端交易":
    "Her zaman, her yerde, çok platformlu terminal işlemleri",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Birden çok terminalle mükemmel uyumludur ve çeşitli senaryoların işlem ihtiyaçlarını herhangi bir zamanda karşılayabilir.",
  随时查看实时行情: "İstediğiniz zaman gerçek zamanlı piyasayı görüntüleyin",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "BTC, ETH, DOGE ve diğer dijital varlıkları kolayca satın alın ve satın",
  获取您关注的加密货币价格变化预警:
    "Önem verdiğiniz kripto para birimlerindeki fiyat değişiklikleri hakkında uyarılar alın",
  "查看比特币现货、期货、期权价格":
    "Bitcoin spotunu, vadeli işlemlerini, opsiyon fiyatlarını görüntüleyin",
  比较各交易所加密货币价格:
    "Borsalardaki kripto para birimi fiyatlarını karşılaştırın",
  开启您的数字货币之旅: "Dijital para birimi yolculuğunuza başlayın",
  快捷购买数字货币: "Hızla dijital para birimi satın alın",
  "使用多种支付方式交易数字货币，安全快捷":
    "Güvenli ve hızlı bir şekilde dijital para birimi ticareti yapmak için birden fazla ödeme yöntemi kullanın",
  最优的交易费率: "Optimum işlem ücreti oranı",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Tercihli işlem oranları, rekabetçi VIP hakları ve en kaliteli hizmetin keyfini çıkarın",
  可信赖的安全保障: "güvenilir güvenlik",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Gelişmiş güvenlik önlemlerimiz ve SAFU fonlarımız, dijital varlıklarınızı tüm risklerden korur.",
  交易: "Ticaret",
  币币市场: "Döviz piyasası",
  "24H成交量": "24 saatlik işlem hacmi",
  交易所: "değiş tokuş",
  "24H最高": "24 saat en yüksek",
  "24H最低": "minimum 24 saat",
  永续合约: "sürekli sözleşmeler",
  日涨跌: "Günlük yükseliş ve düşüş",
  交易深度: "işlem derinliği",
  "资产(合约)": "Varlıklar (sözleşmeler)",
  历史仓位: "Tarihsel konumlar",
  兑换记录: "değişim kaydı",
  类型: "tip",
  充值记录: "Şarj kaydı",
  划转记录: "transfer kaydı",
  类别: "kategori",
  历史账单: "tarihsel fatura",
  在线充值: "Çevrimiçi şarj edin",
  安全设置: "Güvenlik ayarları",
  用于账户登录使用: "Hesap girişi kullanımı için",
  用户提现时安全验证使用:
    "Kullanıcı nakit çektiğinde güvenlik doğrulaması için kullanılır",
  验证: "Doğrulayın",
  万: "On bin",
  随时随地开启交易: "İşlemleri istediğiniz zaman, istediğiniz yerde açın",
  "*货币交易所的所有功能尽在你的手中。":
    "{0}Döviz bozdurmanın tüm fonksiyonları sizin elinizde.",
  "下载*货币交易所APP。": "{0} Döviz Alım Satım Uygulamasını indirin.",
  下载自: "şuradan indir",
  内测版: "Beta sürümü",
  下载: "indirmek",
  扫码下载: "İndirmek için kodu tarayın",
  设置您的资产密码: "Varlık parolanızı belirleyin",
  法币: "Fransız para birimi",
  我要买: "satın almak istiyorum",
  我要卖: "satmak istiyorum",
  请输入金额: "Lütfen tutarı girin",
  汇率: "Döviz kuru",
  获得: "almak",
  支付通道: "ödeme kanalı",
  收款通道: "ödeme kanalı",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Satış işlemi sırasında, ödeme yönteminizin size ait olduğunu doğrulamanız gerekir.",
  当前法币暂不支持交易对可尝试前往提现:
    "Mevcut yasal para birimi ticaret çiftlerini desteklemiyor, para çekmeyi deneyebilirsiniz",
  前往提现: "Nakite git",
  该法币暂无通道: "Bu fiat para birimi için kanal yok",
  "正在出售中，请耐心等待": "Satılık, lütfen sabırlı olun",
  请选择支付通道: "Lütfen ödeme kanalını seçin",
  请选择方式: "Lütfen bir yöntem seçin",
  法币历史: "Fiat tarihi",
  买币: "jeton satın alın",
  卖币: "madeni para satmak",
  失败: "başarısız",
  已完成: "Tamamlandı",
  未付款: "ödenmemiş",
  待审核: "incelenecek",
  打款中: "ödeme",
  订单详情: "sipariş detayları",
  联系客服: "Müşteri Hizmetleri ile İletişime Geçin",
  到账金额: "Fatura tutarı",
  通道: "koridor",
  收款人: "alacaklı",
  收款账户: "Alacak hesapları",
  "订单出售失败，请查下方失败原因":
    "Sipariş satışı başarısız oldu, lütfen aşağıdan başarısızlığın nedenini kontrol edin",
  失败原因: "başarısızlık nedeni",
  您还未进行付款: "Henüz bir ödeme yapmadınız",
  您已成功购买: "Başarıyla satın aldınız",
  已取消订单: "sipariş iptal edildi",
  "订单正在审核中，请耐心等待": "Sipariş inceleniyor, lütfen sabırlı olun",
  您已成功出售: "Başarıyla sattınız",
  "订单正在打款中，请耐心等待": "Sipariş ödeniyor, lütfen sabırla bekleyin",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "Ödeme işlemi, ödeme emri vermek için başka platformlara gitmenizi gerektirmektedir, lütfen bilgi güvenliğine dikkat ediniz.",
  当前法币暂不支持交易对可尝试前往充值:
    "Mevcut yasal para birimi ticaret çiftlerini desteklemiyor, yeniden şarj etmeyi deneyebilirsiniz",
  前往充值: "şarj etmeye git",
  购买: "Satın almak",
  订单号: "sipariş numarası",
  单价: "birim fiyat",
  到账数量: "varış miktarı",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Şu anda ödenmemiş siparişler var, yeni ödeme emirleri vermeye devam etmek istiyor musunuz?",
  继续支付: "ödemeye devam et",
  重新下单: "yeniden sipariş ver",
  是否确定出售: "satacağına emin misin",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "Satış onaylandıktan sonra platform alıcıya atanacaktır, lütfen platformun eşleşmesi için sabırla bekleyin.",
  出售: "satmak",
  收款方式: "Ödeme şekli",
  订单已生成: "sipariş oluşturuldu",
  取消订单: "siparişi iptal et",
  请在: "lütfen",
  内完成付款: "içinde ödemeyi tamamla",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注":
    "Platformdan çıkın, belirttiğiniz ödemeye giriş yapın, satıcının aşağıdaki hesabına havale yapın ve ödemeyi mutlaka not edin",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Ödeme sırasında herhangi bir açıklama yapılmazsa, satıcı ödemenin alındığını teyit edemeyecektir ve bu da geri alınamayacak varlıkların kaybolmasına neden olacaktır.",
  "未在规定的时间内付款，订单都将被取消。":
    "Öngörülen süre içinde ödeme yapılmaması durumunda sipariş iptal edilecektir.",
  姓名: "İsim",
  收款姓名: "Alıcı Adı",
  开户支行: "Hesap açılış şubesi",
  银行卡号: "Banka kartı numarası",
  "付款后，返回本平台": "Ödeme yapıldıktan sonra bu platforma geri dönün",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    'Aşağıdaki "Ödemeyi tamamladım, satıcıya bildir" butonuna tıkladığınızdan emin olun.',
  未点击卖家不会放款: "Satıcı tıklamadan parayı bırakmayacak",
  交易条款: "işlem şartları",
  "购买资金来源，必须合法安全的资金，方可交易":
    "Satın alma fonlarının kaynağı, ticaretten önce yasal ve güvenli fonlar olmalıdır.",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Dolandırıcılık, saadet zinciri, kumar veya diğer yasa dışı finansal işlemlere izin verilmez",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "İşlem tamamlandıktan sonra, dondurulan veya dolandırıcılık, piramit şemaları veya kumar olduğundan şüphelenilen fon riski varsa, artık U'yu alıcıya bırakmayacağız ve geri ödeme yapacağız.",
  "已付款，通知卖家": "Ödendi, satıcıyı bilgilendir",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Alıcı aynı gün içerisinde toplam {0} siparişi iptal ederse, o günkü satın alma fonksiyonu iptal olur. Bu siparişi iptal edeceğinizden emin misiniz?",
  添加收款方式: "Ödeme yöntemi ekle",
  是否删除此收款方式: "Bu ödeme yönteminin silinip silinmeyeceği",
  删除: "silmek",
  请选择法币: "Lütfen itibari para birimini seçin",
  机构名称: "Kurum Adı",
  请选择机构: "Lütfen bir kurum seçin",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "Dijital para sattığınızda, seçtiğiniz ödeme yöntemi alıcıya gösterilecektir, lütfen doğru olduğunu onaylayın.",
  请选择银行: "Lütfen bir banka seçin",
  请输入姓名: "Lütfen adınızı yazın",
  账号: "hesap",
  请输入账号: "lütfen hesaba girin",
  收款码: "makbuz kodu",
  "银行账号/卡号": "Banka hesap numarası/kart numarası",
  "请输入银行账号/卡号": "Lütfen banka hesabı/kart numarası giriniz",
  "开户支行（选填）": "Hesap açılış şubesi (isteğe bağlı)",
  请输入开户支行: "Lütfen hesap açılış şubesini giriniz.",
  "加入*官方频道": "{0}Resmi kanala katılın",
  关于: "hakkında",
  条款: "şartlar",
  其他: "başka",
  成功: "başarı",
  等待: "Bekle",
  作废: "geçersiz",
  确认付款: "ödemeyi Onayla",
  "是否已完成付款？若确认付款后，商家将会在{0}分内进行确认是否收到付款。":
    "Ödeme tamamlandı mı? Ödeme onaylanırsa, satıcı * dakika içinde ödemenin alınıp alınmadığını teyit edecektir.",
  最大金额: "en yüksek miktar",
  最小金额: "minimum miktar",
  付款: "Ödeme",
  法币充值: "Fiat para yükleme",
  法币提现: "Fiat para çekme",
  待支付: "Ödenecek",
  已支付: "Paralı",
  商户名: "Tüccar Adı",
  当前没有添加支付方式: "Şu anda eklenmiş bir ödeme yöntemi yok",
  添加后再出售: "satmak için ekle",
  新人大礼包: "Yeni gelen çılgınlığı",
  注册即可领取: "almak için kaydolun",
  立即领取: "hemen şimdi al",
  不再提示: "tekrar hatırlatma",
  "该奖励需在APP中领取，请下载APP":
    "Ödülün APP'de talep edilmesi gerekiyor, lütfen APP'yi indirin",
  去交易: "Ticaret",
  期权交易: "opsiyon ticareti",
  交易额: "işlem tutarı",
  可用额度: "Mevcut miktar",
  交易周期: "işlem döngüsü",
  看涨: "yükseliş",
  看跌: "düşüş eğilimi",
  当前持有: "şu anda düzenlenen",
  胜率: "Kazanma oranı",
  "盈利/亏损数": "Kar kaybı",
  累计实现盈亏: "Birikmiş kar ve zarar",
  秒: "ikinci",
  分: "Dakika",
  小时: "Saat",
  天: "gökyüzü",
  周: "hafta",
  下单时间: "sipariş zamanı",
  剩余时间: "kalan zaman",
  买入价: "Alış fiyatı",
  结算价: "Uzlaşma Fiyatı",
  实现盈利: "kar elde etti",
  结算时间: "yerleşim zamanı",
  期权: "seçenekler",
  新手教程: "Başlangıç ​​Eğitimi",
  我的订单: "Benim siparişim",
  赔率: "oranlar",
  全部订单: "tüm siparişler",
  持有订单: "bekletme emri",
  历史订单: "Tarihsel düzen",
  输入交易额度: "İşlem tutarını girin",
  选择交易周期: "Bir ticaret döngüsü seçin",
  去注册: "Kayıt olmak",
  冻结: "donmak",
  期权支出: "seçenek ödemesi",
  期权收入: "opsiyon geliri",
  用户提现: "Kullanıcının çekilmesi",
  "是否购买？": "Satın almak istiyor musun?",
  购买成功: "başarılı satın alma",
  请签名: "Lütfen imzalayın",
  提交签名: "imza gönder",
  清空签名: "imzayı temizle",
  签名审核中: "imza incelemesi",
  已提交: "gönderilen",
  扫一扫下载APP: "APP'yi indirmek için tarayın",
  新手领取大礼包: "Acemiler çılgınlık alır",
  注册实名即送彩金: "Gerçek adınızı kaydedin ve bonus kazanın",
  交易总额: "toplam işlem tutarı",
  资产不足: "yetersiz varlık",
  "Win账户的资产不足，可从现货账户划转至此账户":
    "Win hesabında yeterli bakiye yok, buraya para hesabından aktarım yapılabilir.",
  Win: "kazanç",
  在线充值: "Çevrimiçi şarj edin",
  比赛: "Yarışma",
  未开始: "başlamadı",
  赛程: "takvim",
  赛果: "Sonuçlar",
  已结束: "üzerinde",
  让球: "Handikap",
  进球数: "Hedefler",
  大: "Büyük",
  小: "Küçük",
  胜负平: "bağlamak",
  和局: "Bağlamak",
  投注: "bahis",
  下注金额: "bahis miktarı",
  下注: "bahis parası koy",
  阵容: "sıralanmak",
  分析: "analiz etmek",
  输入下注金额: "Bahis miktarını girin",
  下注成功: "başarılı bahis",
  投注记录: "bahis rekoru",
  未结算: "huzursuzluk",
  已结算: "Yerleşik",
  流水: "Akar su",
  输赢: "Kazan yada kaybet",
  赛时: "oyun zamanı",
  下注时间: "bahis zamanı",
  足彩竞猜: "futbol bahisleri",
  查看详情: "ayrıntıları kontrol et",
  输: "kaybetmek",
  赢: "kazanç",
  主: "ev sahibi",
  客: "misafir",
  主胜: "ana galibiyet",
  客胜: "misafir kazanır",
  平: "düz",
  已延期: "ertelenen",
  账号异常: "Anormal hesap",
  全场独赢: "kazanan",
  全场让球: "handikap",
  全场大小: "Tam boy",
  总进球: "toplam gol",
  拍摄照片要求: "fotoğraf çekimi gereksinimleri",
  标准拍摄: "standart atış",
  边框缺失: "kenarlık eksik",
  照片模糊: "bulanık fotoğraf",
  闪光强烈: "güçlü flaş",
  上传手持证件照: "Bir vesikalık fotoğraf yükleyin",
  上传证件照: "Kimlik fotoğrafı yükle",
  换一张: "birini değiştir",
  出生日期: "doğum tarihi",
  请选择出生日期: "Lütfen doğum tarihini seçiniz",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Aşağıya doğru grafik doğrulamayı girdikten sonra, kaydolmak için e-posta doğrulama kodunu alın.",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Hala {0} kimlik doğrulama süreniz kaldı, kimlik doğrulamaya devam edemeyeceğiniz sayıdan sonra",
  上半场: "ilk yarı",
  下半场: "ikinci yarı",
  独赢: "yalnız kazanmak",
  上半场独赢: "ilk yarıyı kazanmak",
  下半场独赢: "ikinci yarıyı kazanmak",
  上半场让球: "ilk yarı handikapı",
  下半场让球: "ikinci yarı handikapı",
  上半场大小球: "İlk yarıda goller",
  下半场大小球: "2. Yarı Golleri",
  波胆: "Kolesterol",
  上半场波胆: "İlk yarı skoru",
  下半场波胆: "İkinci yarı skoru",
  单双: "Tek ve çift",
  上半场单双: "İlk yarıda oranlar ve çiftler",
  下半场单双: "İkinci yarıda oranlar ve çiftler",
  总进球: "toplam gol",
  上半场总进球: "1. Yarıdaki Toplam Gol Sayısı",
  下半场总进球: "İkinci Yarı Toplam Goller",
  单: "bir",
  双: "çift",
  中场: "orta saha oyuncusu",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Not: Beyaz kağıda metin yazmak ve kimliğiniz ile fotoğraf çekmek için lütfen bu örnek resmi takip edin.",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Son zamanlarda, çok sayıda hile hesabı keşfedildi ve bir dizi yasa dışı hesap cezalandırıldı. Herhangi bir hesabın yasa dışı hesap olarak yanlış değerlendirilmesi durumunda, lütfen çevrimiçi müşteri hizmetleriyle iletişime geçin.",
  最小下注金额: "minimum bahis miktarı",
  参与活动最小下注金额: "Etkinliğe katılmak için minimum bahis miktarı",
  记住密码: "şifre hatırlamak",
  比分: "Puan",
  "您还未登录，请先登录": "Giriş yapmadınız, lütfen önce giriş yapın",
  立即登录: "hemen giriş yap",
  下注限额: "bahis limiti",
  可赢金额: "kazanılabilir miktar",
  闪兑详情: "Flaş Ayrıntıları",
  大小球: "boy top",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "Döviz kurundan dolayı bahis tutarı ile gerçek bahis tutarı arasında farklılık olabilir, lütfen sıralamaya bakın.",
  开赛时间: "Başlangıç ​​saati",
  足球收入: "futbol geliri",
  足球支出: "futbol harcamaları",
  活动详情: "aktivite detayları",
  为世界杯喝彩: "dünya kupası için alkış",
  我的竞猜: "tahminimce",
  "竞猜比赛、有机会瓜分*USDT":
    "Oyunu tahmin et ve paylaşma şansı yakala {0}USDT",
  "瓜分*USDT": "{0}USDT'yi böl",
  距离活动结束还有: "Etkinliğin bitmesine daha var",
  我的门票: "biletim",
  竞猜结束时间: "Bitiş zamanını tahmin et",
  猜比分: "skoru tahmin et",
  "福利派送中，完成任务即可获取门票":
    "Refah dağıtımı devam ediyor, bilet almak için görevi tamamlayın",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Aşağıdaki görevleri tamamlayın, yarışmaya katılmak için ilgili sayıda bileti alabilirsiniz.",
  时: "Zaman",
  活动: "Aktivite",
  竞猜记录: "Tahmin rekoru",
  结果: "sonuç",
  任务: "Görev",
  去邀请: "davet etmek",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Her oyunun noktası tahmin edilir ve ${0} yarışma katılmak için ödüllere bölünebilir.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "Sınava katılmak için platformun görevlerine göre alınabilen biletler gerekir.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的现货账户，你可以立即提取。":
    "Yarışma başarılı olduktan sonra, yarışma sonuçlarından bir ekran görüntüsü müşteri hizmetlerine gönderin. Müşteri hizmetleri, para hesabınıza para yatıracak ve hemen para çekebilirsiniz.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Herhangi bir hile yasaktır ve hile tespit edilirse ödüller geçersiz olacaktır.",
  "完成任务后，点击咨询客服获得门票。":
    "Görevi tamamladıktan sonra bileti almak için Müşteri Hizmetlerine Danışın'a tıklayın.",
  继续猜: "tahmin etmeye devam et",
  总单数: "toplam tekil",
  赛事筛选: "Olay taraması",
  球队筛选: "takım seçimi",
  总金额: "Toptan",
  总流水: "toplam ciro",
  派奖金额: "Bonus miktarı",
  下注单数: "Tek sayı bahisi",
  利润: "kâr",
  更多福利: "daha fazla fayda",
  我的奖金: "ikramiyem",
  未认证: "sertifikalı değil",
  总量: "Toplam",
  或: "veya",
  模拟交易: "demo ticaret",
  体验账户不可操作: "Deneyim hesabı kullanılamıyor",
  世界杯比分竞猜: "Dünya Kupası puan testi",
  "领*USDT起": "Şuradan {0}USDT alın",
  消息: "bilgi",
  滚球: "Rolling ball",
  是: "Evet.",
  不是: "Hayır.",
  当前余额: "cari denge",
  KOL招募: "KOL işe alımı",
  本月净输赢: "Ay için net kazanç/kayıp",
  本月佣金: "ayın komisyonu",
  佣金比例: "komisyon oranı",
  活跃人数: "aktif numara",
  新增下级: "Ast ekle",
  登录人数: "giriş sayısı",
  首存人数: "İlk mevduat sahibi sayısı",
  数据分析: "veri analizi",
  人数: "İnsanların sayısı",
  新注册存款金额: "Yeni kayıtlı depozito tutarı",
  老用户存款金额: "Eski kullanıcı depozito miktarı",
  首存金额: "İlk para yatırma tutarı",
  快捷入口: "hızlı giriş",
  成员管理: "üye yönetimi",
  财务报表: "Finansal Tablolar",
  分红报表: "temettü raporu",
  订单记录: "sipariş kaydı",
  VIP专享: "VIP'ye Özel",
  推广工具: "tanıtım aracı",
  计算规则: "Hesaplama Kuralları",
  账变明细: "Hesap değişikliği ayrıntıları",
  成员: "üye",
  下级概览: "Alt genel bakış",
  下级成员总计: "Alt Üyeler Toplam",
  本月新增: "bu ay yeni",
  本月活跃会员: "Ayın aktif üyesi",
  今日活跃会员: "Bugün Aktif Üyeler",
  本月有效活跃: "bu ay aktif",
  活跃成员占比: "Aktif Üye Oranı",
  本月活跃: "bu ay aktif",
  今日活跃: "bugün aktif",
  下级成员: "Yeni Üye",
  会员账号: "üye hesabı",
  统计时间: "İstatistik Zamanı",
  筛选: "filtre",
  存款: "Depozito",
  取款: "para çekmek",
  总输赢: "toplam kazanç veya kayıp",
  是否有效用户: "geçerli bir kullanıcı mı",
  最近登录时间: "son giriş zamanı",
  否: "hayır",
  开始时间: "Başlangıç ​​zamanı",
  结束时间: "Bitiş zamanı",
  提取: "Ayıkla",
  总盈亏: "toplam kar ve zarar",
  净盈亏: "net kar ve zarar",
  分红: "temettüler",
  概览: "genel bakış",
  月度详细数据: "Ayrıntılı aylık veriler",
  未发放: "yayınlanmadı",
  活跃用户: "aktif kullanıcı",
  有效新增会员: "Etkili bir şekilde yeni üyeler ekleyin",
  冲正后净输赢: "Yıkamadan sonra net kazanç veya kayıp",
  上月结余: "Geçen ayın bakiyesi",
  净输赢: "net kazanç/kayıp",
  "系统每日新加坡时间1:00更新一次报表":
    "Sistem her gün Singapur saati 1:00'da raporu güncelleştiriyor.",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "Verilerdeki pozitif sayılar, toplam kazançlar ve kayıplar ve rapordaki net kazançlar ve kayıplar temsilcinin karını, negatif sayılar ise temsilcinin zararını gösterir.",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Komisyon verileri her gün güncellenir ve yalnızca referans amaçlıdır, gerçek komisyon dağıtım standardı değildir.",
  选择时间: "seçim dönemi",
  足球: "Futbol",
  投注金额: "bahis miktarı",
  有效订单: "geçerli sipariş",
  下级账户: "Alt hesap",
  待成交: "bekleyen anlaşma",
  下单金额: "sipariş miktarı",
  订单内容: "sipariş içeriği",
  秒数: "saniye",
  联赛: "Lig",
  队伍: "takım",
  比赛时间: "rekabet zamanı",
  玩法: "nasıl oynanır",
  等级规则表: "Not Kuralı Tablosu",
  等级: "seviye",
  活跃会员: "aktif üye",
  最新活跃: "en son aktif",
  额外佣金: "ekstra komisyon",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "İlgili seviyenin büyüme standardı ve ödül sistemi her ay uygulanır ve yalnızca bir seviye ödülden yararlanılabilir.",
  渠道生成: "kanal üretimi",
  创建: "oluşturmak",
  渠道名称: "Kanal ismi",
  注册人数: "kaydedenlerin sayısı",
  浏览人数: "İzleyiciler",
  构建状态: "yapı durumu",
  禁用: "engelli",
  启用: "etkinleştirme",
  查看: "Kontrol etmek",
  创建渠道: "kanal oluştur",
  创建成功: "başarıyla oluşturuldu",
  操作成功: "Başarılı operasyon",
  渠道详情: "Kanal Ayrıntıları",
  邀请码: "Davet Kodu",
  访问人数: "ziyaretçi sayısı",
  渠道地址: "kanal adresi",
  我的福利: "faydalarım",
  充值福利: "Şarj avantajları",
  当前流水: "akım akışı",
  如何参与: "Nasıl katılacağım",
  币种充值: "Para yükleme",
  充值福利中领取福利: "Ek avantajlardan yararlanın",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Kurallar: Yeniden yükleme avantajı isteğe bağlıdır ve geçerlilik süresi, yeniden yüklemeden sonraki 24 saat içindedir. Son kullanma tarihinden sonra geçersiz olacaktır. Aldıktan sonra, nakit çekme işlevi geçici olarak kilitlenir ve nakit çekme işlemi durdurulabilir. ciroya ulaşıldıktan sonra kilidi açılır.",
  失效日期: "Son kullanma tarihi",
  "暂无福利领取，充值后领取":
    "Henüz alınacak avantaj yok, şarj ettikten sonra alın",
  参与: "Katıl",
  充值赠送: "şarj hediye",
  "领取*%的赠送": "{0}% hediye al",
  去领取: "toplamak",
  VIP奖励: "VIP ödülleri",
  "当前可领取*USDT，是否确认领取":
    "Şu anda {0}USDT alabiliyor, iddiayı onaylıyor musunuz?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "Hak talebinde bulunduktan sonra para çekme işlevi geçici olarak kilitlenir ve cironuz {0}USDT'ye ulaştığında kilit açılabilir.",
  充值送大礼: "Büyük bir hediye almak için doldurun",
  "存入越多，送越多！":
    "Ne kadar çok para yatırırsanız, o kadar çok kazanırsınız!",
  无效: "geçersiz",
  有效: "verimli",
  总存金额: "toplam depozito miktarı",
  提示: "ipucu",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Toplam kazançlar ve kayıplardaki pozitif sayılar ve net kazançlar ve kayıplar platform karlarını, negatif sayılar ise kayıpları gösterir.Günlük veriler yalnızca referans amaçlıdır ve gerçek komisyon dağıtım standardı olarak hizmet etmez.",
  "净盈亏：总盈亏-用户返水":
    "Net kâr ve zarar: toplam kâr ve zarar - kullanıcı indirimi",
  盈利方: "Karlı parti",
  代理: "oyunculuk",
  客户: "müşteri",
  平局: "Berabere",
  平台: "platform",
  "已提交审核，请耐心等待": "İnceleme için gönderildi, lütfen sabırlı olun",
  充值日期: "şarj tarihi",
  平台本月总输赢: "Platformun bu ayki toplam kazançları ve kayıpları",
  KOL招募合作: "KOL işe alım işbirliği",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "Platform açıldı [KOL İşe Alım Etkinliği], bir sosyal medya hesabınız olduğu sürece, platformla bir kereye mahsus olmak üzere müşterileri tanıtma bonusunun tadını çıkarabilir ve ömür boyu avantajlardan yararlanabilirsiniz.",
  级别: "seviye",
  平台利润返佣: "Platform kar indirimi",
  佣金案例: "komisyon davası",
  交易项目: "işlem kalemi",
  "期权交易、合约交易、足球游戏":
    "Opsiyon ticareti, sözleşme ticareti, futbol oyunları",
  报名方式: "kayıt yolları",
  点击KOL招募报名: "KOL işe alım kaydına tıklayın",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Ekibimize katılmaya hoş geldiniz, platform kendi kullanıcı sisteminizi kurmanız için sizi tamamen destekliyor ve en yüksek{0} komisyonu alabilirsiniz, katılmanızı dört gözle bekliyoruz.",
  输入联系方式: "İletişim bilgilerini girin",
  最低活跃人数: "Asgari Aktif Numara",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "Örneğin: bu ayki aktif kullanıcı sayısı ≥ {0} ve platformun bu ayki toplam kazancı veya kaybı ≥ {1}USDT, seviyeye aitsiniz {2}, {3}% komisyon alabilirsiniz.",
  比分竞猜: "Score quiz",
  豪礼相赠: "Gift",
  足球活动: "Futbol etkinliği",
  圣诞节活动: "Noel etkinliği",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Etkinliğe katıldınız ve geçici olarak çekme fonksiyonunu kilitlediniz. Kilitlemek için {0} USDT akışı gerekiyor.",
  剩余流水: "Kalan su",
  助力足球: "Futbol arttırma",
  佣金累计: "Toplam komisyon",
  有效投注: "Geçerli bahis",
  今日: "Bugün",
  今日返水: "Indirim bugün",
  VIP返水: "VIP indirimi",
  返水记录: "İndirim kaydı",
  成员信息: "üye bilgisi",
  基本信息: "Temel Bilgiler",
  钱包余额: "Cüzdan bakiyesi",
  投注信息: "Bahis bilgileri",
  返水: "Indirim",
  总下注: "Toplam bahis",
  今日输赢: "Bugün kazan ya da kaybet",
  下注动态: "Bahis Dinamikleri",
  返水奖励: "Indirim bonusu",
  分红金额: "Temettü tutarı",
  返水支出: "Indirim ödemesi",
  总返水: "Toplam indirim",
  流水总额: "Toplam ciro",
  返水总额: "Toplam İndirim",
  返水详情: "İndirim Ayrıntıları",
  日流水: "Günlük su",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "Platform, astınızın günlük cirosuna göre ek indirim ödülleri sağlar ve ödüller her gün Singapur saatiyle 00:00'da ödül hesabına dağıtılır.",
  "申请成功，等待审核": "Başvuru başarılı, incelenmeyi bekliyor",
  "我出本金，盈利共分享": "Anaparayı ödüyorum ve karı paylaşıyorum",
  最高分红: "en yüksek temettü",
  投资大师比赛: "Yatırım Ustası Yarışması",
  "我出本金，你盈利": "ben anaparayı öderim sen kazanırsın",
  共分享: "paylaşılan",
  最高分红可得: "Mevcut maksimum temettüler",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Yeni kullanıcılar için özel avantajlar geliyor, ücretsiz ${0}, aldıktan sonra platformdaki herhangi bir projeye yatırım yapabilir ve kar elde ettikten hemen sonra çekebilirsiniz.",
  报名领取: "almak için kaydolun",
  已领取: "kabul edilmiş",
  审核驳回: "İnceleme reddedildi",
  驳回原因: "reddedilme nedeni",
  活动运行周期: "Etkinlik çalıştırma döngüsü",
  "申请成功后起至*天内完成超额收益。":
    "Başvuru başarılı olduktan sonra fazla gelir {0} gün içinde tamamlanacaktır.",
  分红比: "temettü oranı",
  "*日获得盈利后，可获得*%的收益额。":
    "{0} gününde kazanç elde ettikten sonra, karın %{1}'sini alabilirsiniz.",
  参与条件: "katılım koşulları",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Rusya ve Türkiye'deki kullanıcılar katılmadı.",
  计算项目: "hesaplama öğesi",
  "合约、体育、期权": "Sözleşmeler, Spor, Seçenekler",
  我的投资: "yatırımım",
  参与天数: "katılım günleri",
  累计下注: "kümülatif bahis",
  累计盈亏: "Birikmiş kar ve zarar",
  预计可分红: "Temettü ödemesi bekleniyor",
  常见问题: "ortak sorun",
  什么是平台出资: "platform finansmanı nedir",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "Bazı ülkelerdeki kullanıcılara göre platform, kullanıcılara projelere yatırım yapmaları için ücretsiz fon sağlıyor.",
  怎么获取平台出资的福利:
    "Platform katkısının avantajlarından nasıl yararlanılır?",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Yalnızca belirlenen bir ülkede kullanıcı olmanız, yukarıdaki kayıt düğmesine tıklamanız yeterlidir ve {0}USDT, platform incelemesi tamamlandıktan sonra cari hesap altındaki bounty hesabına aktarılır ve diğer hesaplara yatırım için aktarabilirsiniz.",
  什么是分红: "temettü nedir",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Temettü, gelirin %100'e ulaşmasından sonra belirli bir süre içinde fazla gelirin % 50'sinin dağıtılabilmesi anlamına gelir. Örneğin: 100USDT fonu almak için gelir miktarı %120'dir.",
  "如何取得分红？": "Nasıl temettü alınır?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "Etkinlik döngüsü her {0}günde birdir.Aktivite bittikten sonra hesaplanacak ve etkinlik gereksinimleri karşılandıktan sonra temettüler bounty hesabına dağıtılacaktır. Etkinlik gereksinimlerini karşılamıyorsanız, sistem otomatik olarak gelirinizi ve platform katkı paylarınızı mahsup edecektir.",
  活动规则: "Etkinlik Kuralları",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Katılımcı hesapların KYC doğrulamasından geçmesi gerekir ve her hesap bir avantajla sınırlıdır.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "Katılımcı hesapların KYC'si, belirtilen ülkenin katılmasını gerektirir ve diğer bölgelerin katılma yetkisi yoktur.Lütfen aktif ülkenin ülkenizle tutarlı olup olmadığını kontrol edin.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "Etkinliğe başarılı bir şekilde katıldıktan sonra hesap, para çekme işlevinizi geçici olarak kilitleyecek ve etkinlik tamamlandıktan sonra para çekme işleviniz kullanımdan kaldırılacaktır.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Lütfen platform etkinlik kurallarına uyun.Hile veya suiistimal amaçlı sistem boşlukları bulursanız, platform hesabınızdaki tüm fonları uzun süre dondurur.",
  平台出资: "Platform yatırımı",
  平台出资收回: "Platform yatırım kurtarma",
  投资大师奖励: "Yatırım Ustası Ödülü",
  请下载APP添加收款方式:
    "Bir ödeme yöntemi eklemek için lütfen uygulamayı indirin",
  请下载APP进行身份验证: "Lütfen kimlik doğrulaması için APP'yi indirin",
  请下载APP参与: "Katılmak için lütfen uygulamayı indirin",
  技术指标: "Teknik göstergeler",
  主图: "Ana resim",
  副图: "Alt resim",
  新注册人数: "Yeni kayıt yaptıranlar",
  老用户存款人数: "Eski kullanıcı mevduatları",
  存款人数: "Mevduat sayısı",
  取款人数: "Para çekme sayısı",
  投注人数: "Bahisçi sayısı",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "Endonezya, Hindistan, Bangladeş ve katılmamış kullanıcılar hariç.",
  市场动态: "Pazar dinamikleri",
  外汇合约: "döviz sözleşmesi",
  盈亏比: "kar-zarar oranı",
  委托价: "Sipariş fiyatı",
  可用余额: "Kalan bakiye",
  持仓额: "Pozisyon miktarı",
  强平价: "Güçlü parite",
  修改: "Tekrar düzeltme yapmak",
  修改价位: "Fiyatı değiştir",
  外汇: "Forex",
  外汇账户: "Forex hesabı",
  我的交易: "benim işlemim",
  未设置: "ayarlanmamış",
  超出最大可设数值: "Ayarlanabilir maksimum değeri aşıyor",
  超出最小可设数值: "Minimum ayarlanabilir değeri aşıyor",
  止盈超出最小可设数值: "Kar alma minimum ayarlanabilir değeri aşıyor",
  止损超出最大可设数值: "Zararı durdur, ayarlanabilir maksimum değeri aşıyor",
  止盈超出最大可设数值: "Kar alma maksimum ayarlanabilir değeri aşıyor",
  止损超出最小可设数值: "Durdurma kaybı minimum ayarlanabilir değeri aşıyor",
  挖矿: "madencilik",
  交易账户: "işlem hesabı",
  买涨: "Hepsini satın al",
  买跌: "Satın al veya sat",
  请输入正确的银行卡信息: "Lütfen doğru banka kartı bilgilerini girin",
  联系在线客服: "Çevrimiçi müşteri hizmetlerine başvurun",
  法币交易请联系在线客服:
    "Yasal para birimi işlemleri için lütfen çevrimiçi müşteri hizmetleriyle iletişime geçin.",
  提交订单: "Siparişi Gönder",
  "支付过程如有疑问,请联系在线客服":
    "Ödeme süreciyle ilgili herhangi bir sorunuz varsa lütfen çevrimiçi müşteri hizmetleriyle iletişime geçin.",
  彩金赠送: "Lottery hediye",
  在线客服: "çevrimiçi servis",
  最少投资: "minimum yatırım",
  "提交时间:": "Gönderim zamanı:",
  提现拒绝: "Para çekme reddedildi",
  认证拒绝: "Kimlik doğrulama reddedildi",
  认证通过: "Sertifika geçti",
  请输入正确的交易额度: "Lütfen doğru işlem tutarını girin",
  最大下注金额: "Maksimum bahis tutarı",
  手机号: "Telefon numarası",
  邮箱注册: "e-posta kaydı",
  手机号注册: "Cep telefonu numarası kaydı",
  查询: "Sormak",
  手机号登录: "Cep telefonu numarası girişi",
  邮箱登录: "E-posta Girişi",
  请输入数量: "Lütfen miktarı girin",
  可用数量: "Mevcut miktar",
  钱包登录: "Cüzdan girişi",
  请输入正确的邀请码: "Lütfen doğru davet kodunu girin",
  "请输入邀请码(必填)": "Lütfen davetiye kodunu giriniz (gerekli)",
  输入正确的金额: "Doğru tutarı girin",
  法币充值: "milli para ile yeniden yükleme",
  卢比充值: "Rupi Yükleme",
  请输入法币: "Lütfen Para Birimi Girin",
  请输入IFSC: "Lütfen IFSC Girin",
  "银行编码(选填)": "Banka Kodu (İsteğe Bağlı)",
  请输入银行编码: "Lütfen Banka Kodu Girin",
  请输入大于8位数的密码: "Lütfen 8 haneden büyük bir şifre giriniz",
  添加成功: "Başarıyla eklendi",
  "60秒": "60 saniye",
  "180秒": "180 saniye",
  "300秒": "300 saniye",
  "2次密码不一致": "2 şifre tutarsız",
  输入提币数量: "Para çekme tutarını girin",
  图片格式不正确: "Resim formatı yanlış",
  图片大于20M: "Resim 20M'den büyük",
  请设置委托价格: "Lütfen bir komisyon ücreti belirleyin",
  输入资金密码: "Fon şifresini girin",
  验证码错误: "Doğrulama kodu hatası",
  充值拒绝: "Yeniden şarj reddedildi",
  请输入SSN: "Lütfen SSN'yi girin",
  合约交易: "sözleşme ticareti",
  结算完成: "Ödeme tamamlandı",
  继续下单: "Sipariş vermeye devam et",
  最低购买: "minimum satın alma",
  最高购买: "en yüksek satın alma",
  限价: "Limit Fiyat",
  买入价格: "Alış Fiyatı",
  买入量: "Alış Miktarı",
  卖出价格: "Satış Fiyatı",
  卖出量: "Satış Miktarı",
  买入: "Al",
  卖出: "Sat",
  订单创建成功: "Sipariş Başarıyla Oluşturuldu",
  币币买入支出: "Kripto Alım Harcaması",
  币币买入支出退还: "Kripto Alım Harcaması İadesi",
  币币买入获得: "Alımda Elde Edilen Kripto",
  币币卖出支出: "Kripto Satış Harcaması",
  币币卖出支出退还: "Kripto Satış Harcaması İadesi",
  币币卖出获得: "Satışta Elde Edilen Kripto",
  币币交易手续费: "Kripto İşlem Ücreti",
  请输入限价: "Lütfen Limit Fiyatını Girin",
  成交: "Tamamlandı",
  等待成交: "Tamamlanmayı Bekliyor",
  交易完成: "İşlem Tamamlandı",
  被取消: "İptal Edildi",
  交易时间: "İşlem Zamanı",
  法币交易: "Fiat para ticareti",
  法币出售: "Fiat para satışı",
  两次密码不一致: "İki şifre eşleşmiyor",
  再次输入账户密码: "Hesap şifresini tekrar girin",

  美国: "Amerika Birleşik Devletleri",
  韩国: "Güney Kore",
  阿尔巴尼亚: "Arnavutluk",
  津巴布韦: "Zimbabve",
  赞比亚: "Zambiya",
  也门: "Yemen",
  美属维尔京群岛: "ABD Virgin Adaları",
  英属处女群岛: "İngiliz Virgin Adaları",
  越南: "Vietnam",
  委内瑞拉: "Venezuela",
  瓦努阿图: "Vanuatu",
  乌兹别克斯坦: "Özbekistan",
  乌拉圭: "Uruguay",
  英国: "Birleşik Krallık",
  阿拉伯联合酋长国: "Birleşik Arap Emirlikleri",
  乌克兰: "Ukrayna",
  乌干达: "Uganda",
  特克斯和凯科斯群岛: "Turks ve Caicos Adaları",
  土库曼斯坦: "Türkmenistan",
  土耳其: "Türkiye",
  突尼斯: "Tunus",
  特立尼达和多巴哥: "Trinidad ve Tobago",
  汤加: "Tonga",
  多哥: "Togo",
  东帝汶: "Doğu Timor",
  泰国: "Tayland",
  坦桑尼亚: "Tanzanya",
  塔吉克斯坦: "Tacikistan",
  中国台湾: "Tayvan (Çin)",
  叙利亚: "Suriye",
  瑞士: "İsviçre",
  瑞典: "İsveç",
  斯威士兰: "Esvatini",
  苏里南: "Surinam",
  苏丹: "Sudan",
  斯里兰卡: "Sri Lanka",
  西班牙: "İspanya",
  南非: "Güney Afrika",
  索马里: "Somali",
  所罗门群岛: "Solomon Adaları",
  斯洛文尼亚: "Slovenya",
  斯洛伐克: "Slovakya",
  "圣马丁岛（荷兰部分）": "Saint Martin (Hollanda)",
  新加坡: "Singapur",
  塞拉利昂: "Sierra Leone",
  塞舌尔: "Seyşeller",
  塞尔维亚: "Sırbistan",
  塞内加尔: "Senegal",
  沙特阿拉伯: "Suudi Arabistan",
  圣多美和普林西比: "São Tomé ve Príncipe",
  圣马力诺: "San Marino",
  萨摩亚: "Samoa",
  圣克里斯托弗和尼维斯: "Saint Kitts ve Nevis",
  圣文森特和格林纳丁斯: "Saint Vincent ve Grenadinler",
  圣彼埃尔和密克隆岛: "Saint Pierre ve Miquelon",
  圣露西亚: "Saint Lucia",
  圣基茨和尼维斯: "Saint Kitts ve Nevis",
  卢旺达: "Ruanda",
  俄罗斯: "Rusya",
  罗马尼亚: "Romanya",
  留尼汪: "Réunion",
  刚果共和国: "Kongo Cumhuriyeti",
  卡塔尔: "Katar",
  波多黎各: "Porto Riko",
  葡萄牙: "Portekiz",
  波兰: "Polonya",
  菲律宾: "Filipinler",
  秘鲁: "Peru",
  巴拉圭: "Paraguay",
  巴布亚新几内亚: "Papua Yeni Gine",
  巴拿马: "Panama",
  巴勒斯坦: "Filistin",
  帕劳: "Palau",
  巴基斯坦: "Pakistan",
  阿曼: "Umman",
  挪威: "Norveç",
  尼日利亚: "Nijerya",
  尼日尔: "Nijer",
  尼加拉瓜: "Nikaragua",
  新西兰: "Yeni Zelanda",
  新喀里多尼亚: "Yeni Kaledonya",
  荷属安德列斯群岛: "Hollanda Antilleri",
  荷兰: "Hollanda",
  尼泊尔: "Nepal",
  纳米比亚: "Namibya",
  缅甸: "Myanmar",
  莫桑比克: "Mozambik",
  摩洛哥: "Fas",
  蒙特塞拉特岛: "Montserrat",
  黑山: "Karadağ",
  蒙古: "Moğolistan",
  摩纳哥: "Monako",
  摩尔多瓦: "Moldova",
  墨西哥: "Meksika",
  马约特: "Mayotte",
  毛里求斯: "Mauritius",
  毛里塔尼亚: "Moritanya",
  马里亚纳群岛: "Mariana Adaları",
  马提尼克: "Martinik",
  马耳他: "Malta",
  马里: "Mali",
  马尔代夫: "Maldivler",
  马来西亚: "Malezya",
  马拉维: "Malavi",
  马达加斯加: "Madagaskar",
  马其顿: "Kuzey Makedonya",
  中国澳门: "Makao (Çin)",
  卢森堡: "Lüksemburg",
  立陶宛: "Litvanya",
  列支敦士登: "Lihtenştayn",
  利比亚: "Libya",
  利比里亚: "Liberya",
  莱索托: "Lesotho",
  黎巴嫩: "Lübnan",
  拉脱维亚: "Letonya",
  老挝: "Laos",
  吉尔吉斯斯坦: "Kırgızistan",
  科威特: "Kuveyt",
  基里巴斯: "Kiribati",
  肯尼亚: "Kenya",
  哈萨克斯坦: "Kazakistan",
  约旦: "Ürdün",
  日本: "Japonya",
  牙买加: "Jamaika",
  象牙海岸: "Fildişi Sahili",
  意大利: "İtalya",
  以色列: "İsrail",
  爱尔兰: "İrlanda",
  伊拉克: "Irak",
  伊朗: "İran",
  印度尼西亚: "Endonezya",
  印度: "Hindistan",
  冰岛: "İzlanda",
  匈牙利: "Macaristan",
  中国香港: "Hong Kong (Çin)",
  洪都拉斯: "Honduras",
  海地: "Haiti",
  圭亚那: "Guyana",
  几内亚比绍共和国: "Gine-Bissau",
  几内亚: "Gine",
  危地马拉: "Guatemala",
  关岛: "Guam",
  瓜德罗普岛: "Guadeloupe",
  格林纳达: "Grenada",
  格陵兰岛: "Grönland",
  希腊: "Yunanistan",
  直布罗陀: "Cebelitarık",
  加纳: "Gana",
  德国: "Almanya",
  格鲁吉亚: "Gürcistan",
  冈比亚: "Gambiya",
  加蓬: "Gabon",
  法属波利尼西亚: "Fransız Polinezyası",
  法属圭亚那: "Fransız Guyanası",
  法国: "Fransa",
  芬兰: "Finlandiya",
  斐济: "Fiji",
  法罗群岛: "Faroe Adaları",
  埃塞俄比亚: "Etiyopya",
  爱沙尼亚: "Estonya",
  厄立特里亚: "Eritre",
  赤道几内亚: "Ekvator Ginesi",
  萨尔瓦多: "El Salvador",
  埃及: "Mısır",
  厄瓜多尔: "Ekvador",
  多米尼加共和国: "Dominik Cumhuriyeti",
  多米尼加: "Dominika",
  吉布提: "Cibuti",
  丹麦: "Danimarka",
  捷克: "Çekya",
  塞浦路斯: "Kıbrıs",
  库拉索: "Curaçao",
  古巴: "Küba",
  克罗地亚: "Hırvatistan",
  哥斯达黎加: "Kosta Rika",
  科特迪瓦: "Fildişi Sahili",
  库克群岛: "Cook Adaları",
  科摩罗: "Komorlar",
  哥伦比亚: "Kolombiya",
  智利: "Şili",
  乍得: "Çad",
  中非共和国: "Orta Afrika Cumhuriyeti",
  佛得角: "Cabo Verde",
  开曼群岛: "Cayman Adaları",
  开普: "Cape",
  加拿大: "Kanada",
  喀麦隆: "Kamerun",
  柬埔寨: "Kamboçya",
  布隆迪: "Burundi",
  布基纳法索: "Burkina Faso",
  保加利亚: "Bulgaristan",
  文莱: "Brunei",
  巴西: "Brezilya",
  博茨瓦纳: "Botsvana",
  波斯尼亚和黑塞哥维那: "Bosna-Hersek",
  玻利维亚: "Bolivya",
  不丹: "Butan",
  百慕大群岛: "Bermuda",
  贝宁: "Benin",
  伯利兹: "Belize",
  比利时: "Belçika",
  白俄罗斯: "Belarus",
  巴巴多斯: "Barbados",
  孟加拉国: "Bangladeş",
  巴林: "Bahreyn",
  巴哈马: "Bahamalar",
  阿塞拜疆: "Azerbaycan",
  奥地利: "Avusturya",
  澳大利亚: "Avustralya",
  阿鲁巴: "Aruba",
  亚美尼亚: "Ermenistan",
  阿根廷: "Arjantin",
  安提瓜和巴布达: "Antigua ve Barbuda",
  安圭拉: "Anguilla",
  安哥拉: "Angola",
  安道尔: "Andorra",
  美属萨摩亚: "Amerikan Samoası",
  阿尔及利亚: "Cezayir",
  中国: "Çin",

  日收益: "Günlük Kazanç",
  "30天预期收益": "30 Günlük Beklenen Kazanç",
  英伟达高速矿机: "NVIDIA Yüksek Hızlı Madencilik Makinesi",
  去投资: "Yatırımlara Git",
  新币榜: "Yeni Para Birimleri Listesi",
  主题: "Konu",
  立即探索: "Hemen Keşfet",
  等您来: "Sizi Bekliyoruz",
  最新活动: "Son Etkinlikler",
  货币划转: "Para Birimi Transferi",
  提现钱包: "Para Çekme Cüzdanı",
  加密合约: "Şifreli Sözleşme",
  外汇期货: "Döviz Vadeli İşlem",
  定期: "Süreli",
  探索产品: "Ürünleri Keşfet",
  稳健型: "Güvenilir Tip",
  高收益: "Yüksek Getiri",
  期货账户: "Vadeli İşlem Hesabı",
  时间线: "Zaman Çizelgesi",
  收藏: "Favoriler",
  委托订单: "Vekalet Emirleri",
  最新交易: "Son İşlemler",
  深度图: "Derinlik Grafiği",
  标记价格: "İşaret Fiyatı",
  "24h最高价": "24 Saatlik En Yüksek Fiyat",
  "24h成交量": "24 Saatlik İşlem Hacmi",
  "24h最低价": "24 Saatlik En Düşük Fiyat",
  "24h成交额": "24 Saatlik İşlem Tutarı",
  "价格(USDT)": "Fiyat (USDT)",
  "数量(ETH)": "Miktar (ETH)",
  看空: "Alçak Beklenti",
  余额不足: "Yetersiz Bakiye",
  最低购买: "Minimum Satın Alma Miktarı",
  最高购买: "Maksimum Satın Alma Miktarı",
  下单成功: "Emir Başarıyla Verildi",
  平仓成功: "Pozisyon Başarıyla Kapatıldı",
  请输入正确的平仓数量: "Lütfen Doğru Pozisyon Kapatma Miktarını Girin",
  加仓成功: "Pozisyon Başarıyla Artırıldı",
  请输入正确的加仓金额: "Lütfen Doğru Pozisyon Artırma Tutarını Girin",
  收藏成功: "Favorilere Başarıyla Eklendi",
  取消收藏成功: "Favorilerden Başarıyla Kaldırıldı",
  日收益率: "Günlük Getiri Oranı",
  轻松理财: "Kolay Varlık Yönetimi",
  立即申购: "Hemen Abone Ol",
  申购日期: "Abone Olma Tarihi",
  加密货币: "Kripto Para Birimi",
  交割合约: "Teslimat Sözleşmesi",
  最小投资: "Minimum Yatırım Miktarı",
  委托: "Vekalet",
  "当指数价格触达时，将会触发委托平仓":
    "Endeks fiyatına ulaşıldığında, vekalet pozisyon kapatma tetiklenir",
  预计盈利: "Beklenen Kazanç",
  最大投资: "Maksimum Yatırım Miktarı",
  现货交易: "Kripto İşlem",
  输入交易金额: "İşlem Tutarını Girin",
  "可用额度：": "Kullanılabilir Limit:",
  提现货币: "Para Çekme Para Birimi",
  期货合约: "Vadeli İşlem Sözleşmesi",
  加密币永续: "Kripto Süresiz",
  外汇永续: "Forex Süresiz",
  期权账户: "Opsiyon Hesabı",
  夜间模式: "Gece modu",
  未结盈亏: "Gerçekleşmemiş kâr ve zarar",
  超额收益: "Aşırı kazanç",
  "安全策略，低买高卖": "Güvenlik stratejileri, düşük satış",
  投资金额应为: "Yatırım miktarı",
  总收益率: "Toplam kazanç oranı",
  赎回成功: "Başarılı kurtarma",
  快捷卖币: "Hızlı Sat",
  修改止盈止损: "TP/SL'yi değiştir",
  白皮书: "Beyaz Kitap",
  托管资金: "Yönetilen fonlar",
  托管中: "Yönetimde",
  预计日收益: "Tahmini günlük getiri",
  累计收益: "Toplam kazanç",
  周期: "Dönem",
  日收益: "Günlük getiri",
  限额: "Limit",
  立即托管: "Hemen yatırım yap",
  "已鎖定 請聯繫客服": "Kilitli, lütfen müşteri hizmetleriyle iletişime geçin",
  产品列表: "Ürün listesi",
  规则: "Kurallar",
  创建订单: "Sipariş oluştur",
  产品名称: "Ürün adı",
  托管周期: "Yönetim süresi",
  等级限制: "Seviye kısıtlaması",
  托管金额: "Yatırım tutarı",
  限额: "Limit",
  余额: "Bakiye",
  购买日: "Satın alma tarihi",
  起息日: "Faiz başlangıç tarihi",
  派息时间: "Temettü ödeme zamanı",
  每天: "Her gün",
  计息结束日: "Faiz bitiş tarihi",
  每日收益: "Günlük kazanç",
  预计收益: "Tahmini kazanç",
  "收益将自动发送至您的余额账户;":
    "Kazançlar otomatik olarak bakiye hesabınıza gönderilecektir;",
  "您的资金没有任何风险;": "Fonlarınız tamamen güvenlidir;",
  "365*24小时不断地工作;": "Yılın 365 günü 24 saat çalışır;",
  托管中: "Yönetimde",
  结束: "Tamamlandı",
  今日收益: "Bugünkü kazanç",
  剩余周期: "Kalan süre",
  进行中: "Devam ediyor",
  已发放: "Ödendi",
  信誉分: "İtibar puanları",

  复制成功: "Başarıyla kopyalandı",
  VIP权益: "VIP avantajları",
  旧密码: "Eski şifre",
  请输入旧密码: "Eski şifrenizi girin",
  "忘记旧密码请联系客服重置。":
    "Eski şifrenizi unuttuysanız, sıfırlamak için lütfen müşteri hizmetleriyle iletişime geçin.",
  去升级: "Yükselt",
  描述: "Açıklama",
  实际存款金额: "Gerçek yatırma tutarı",
  升级礼金: "Yükseltme bonusu",
  隔夜利息: "Gecelik faiz (swap)",
  自动结算: "Otomatik takas",
  等级规则: "Seviye kuralları",
  "WEB3.0币持有数据收益": "WEB3.0 coin tutma veri getirisi",
  总生产: "Toplam üretim",
  有效节点: "Aktif düğümler",
  参与人: "Katılımcılar",
  用户收益: "Kullanıcı getirisi",
  "流动性WEB3.0输出": "Likidite WEB3.0 çıktısı",
  总资产: "Toplam varlıklar",

  ETHAI持有数据收益: "ETHAI tutum verisi getirisi",
  AI量化流动性: "AI nicel likidite",
  现货买入手续费: "Spot alım ücreti",
  现货支出: "Spot harcama",
  现货资金费率: "Spot fonlama oranı",
  现货卖出手续费: "Spot satım ücreti",
  现货收入: "Spot gelir",
  外汇合约支出: "Döviz sözleşmesi harcaması",
  外汇合约买入手续费: "Döviz sözleşmesi alım ücreti",
  外汇合约资金费率: "Döviz sözleşmesi fonlama oranı",
  外汇合约卖出手续费: "Döviz sözleşmesi satım ücreti",
  外汇合约收入: "Döviz sözleşmesi geliri",
  理财购买: "Varlık yönetimi satın alımı",
  VIP理财日收益: "VIP varlık yönetimi günlük getiri",
  VIP理财隔夜利息: "VIP varlık yönetimi gecelik faiz",
  VIP本金返还: "VIP anapara iadesi",
  VIP彩金发放: "VIP bonus dağıtımı",
  VIP彩金抵扣: "VIP bonus kesintisi",
  隔夜利息: "Gecelik faiz",
  设置资产密码: "Varlık şifresini ayarla",

  锁仓挖矿: "Kilitli madencilik",
  一站式理财服务: "Tek noktadan finansal hizmet",
  产品: "Ürünler",
  客服中心: "Müşteri hizmetleri merkezi",
  贷款: "Krediler",
  挖矿赚不停: "Kesintisiz madencilik kazancı",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Kilitli madencilik, USDT (USD:1USDT=1USD) varlıklarının platformun yüksek işlem gücüne sahip madencilik cihazlarına emanet edilerek platform havuzunda kazanç elde edilmesidir.",
  产品优势: "Ürün avantajları",
  随存随取: "İstediğin zaman yatır ve çek",
  锁仓周期: "Kilit süresi",
  每日下发: "Günlük dağıtım",
  随机空投: "Rastgele airdrop",
  "100%资金安全保障": "100% fon güvenliği garantisi",
  "100%节假日收益不间断": "Tatillerde bile %100 kesintisiz kazanç",
  成功锁仓后当天产出: "Başarılı kilitlemeden sonra aynı gün kazanç başlar",
  关于违约金: "Ceza hakkında",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Vade dolmadan anaparanızı çekmek isterseniz ceza uygulanır. Ceza = ceza oranı × kalan gün × kilitli tutar.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Örnek: ceza oranı %5, kalan süre 3 gün ve kilitli tutar 10000U (USDT/USD). Ceza = %5×3×10000=1500U, iade edilen net tutar 15000U-1500U.",
  收益计算: "Getiri hesaplama",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "Platform, kilitli madencilik için çeşitli finansal ürünler sunar. Getiri hesaplaması aşağıdaki gibidir, örnek:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Kullanıcı 10000U (USDT, USD) kilitlediğinde ve 7 günlük, günlük %0.7~%1.8 getiri sağlayan bir ürün seçtiğinde günlük kazanç:",
  "最低:10000Ux0.7%=70U;": "Minimum: 10000U×%0.7=70U;",
  "最高:10000Ux1.8%=180U;": "Maksimum: 10000U×%1.8=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "7 gün sonunda 490U~1260U arası kazanç elde edilir. Kazançlar günlük dağıtılır ve vade sonunda ana para otomatik olarak hesabınıza aktarılır.",
  正在托管的资金: "Yönetilen fonlar",
  签到: "Giriş yap",
  锁仓订单: "Kilitli emirler",
  预计今日收益: "Bugünkü tahmini kazanç",
  累计收益: "Toplam kazanç",
  托管中的订单: "Yönetimdeki emirler",
  单笔最少: "Minimum işlem tutarı",
  单笔最多: "Maksimum işlem tutarı",
  日收益率: "Günlük getiri oranı",
  说明: "Açıklama",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Veriler GMT+8 saatine göre hesaplanır<br>2. Günlük kazanç, 00:00-23:59 GMT+8 arasındaki tüm kapatılmış emirler üzerinden hesaplanır<br>3. Kazançlar ertesi gün 00:00-00:10 GMT+8 arasında dağıtılır.",
  知道了: "Anladım",
  锁仓: "Kilitle",
  派息时间: "Ödeme zamanı",
  每日: "Günlük",
  托管资金: "Yönetilen fonlar",
  到期返回: "Vade sonunda iade",
  提前赎回: "Erken çekim",
  预计收益: "Tahmini kazanç",
  认购: "Abonelik",
  热门: "Popüler",
  数字货币: "Kripto para",
  贵金属: "Değerli metaller",
  大宗商品: "Emtialar",
  持仓明细: "Pozisyon detayları",
  历史明细: "Geçmiş",
  当前价: "Güncel fiyat",
  "↑买涨": "↑ Yükseliş al",
  "↓买跌": "↓ Düşüş al",
  显示全部: "Tümünü göster",
  买入金额: "Alım tutarı",
  方向: "Yön",
  收益: "Kar",
  预期收益: "Beklenen kar",
  估用保证金: "Tahmini teminat",
  确认下单: "Emri onayla",
  锁定: "Kilitle",
  账户总资产: "Toplam hesap varlığı",
  明细: "Detaylar",
  今日收益: "Bugünkü kazanç",
  仓位保证金: "Pozisyon teminatı",
  持有仓位: "Açık pozisyonlar",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Kilitli tutar = tüm tamamlanmamış kilitli madencilik emirlerinin toplamı",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Veriler GMT+8'e göre hesaplanır<br>2. Günlük kazanç kapatılmış emirler üzerinden hesaplanır",
  充值方式: "Para yatırma yöntemi",
  银行汇款: "Banka havalesi",
  "银行汇款请联系客服进行操作!":
    "Lütfen banka havalesi için müşteri hizmetleri ile iletişime geçin!",
  提款方式: "Para çekme yöntemi",
  "银行提款请联系客服进行操作!":
    "Lütfen banka çekimi için müşteri hizmetleri ile iletişime geçin!",
  资金明细: "Fon detayları",
  提现记录: "Para çekme geçmişi",
  拒绝: "Reddedildi",
  通过: "Onaylandı",
  拒绝原因: "Red nedeni",

  消息公告: "Duyurular",
  订单: "Siparişler",
  个人中心: "Kişisel merkez",
  "未到期赎回需支付一定的违约金!":
    "Vade dolmadan yapılan geri alımlarda ceza ücreti ödenmelidir.",

  请输入区号: "Lütfen alan kodunu girin",
  "请选择国家/地区": "Lütfen ülke/bölge seçin",

  今日开盘: "Bugünkü açılış",
  昨日收盘: "Dünkü kapanış",

  实名认证即送: "Kimlik doğrulamasından sonra hemen alın",
  立即认证: "Şimdi doğrula",
  新用户礼包: "Yeni Kullanıcı Hediye Paketi",
  完成新人任务领取: "Yeni kullanıcı görevlerini tamamlayarak alın",
  认证: "Doğrula",
  时间周期: "Zaman Süresi",
  支付金额: "Ödeme Tutarı",
  已平仓: "Kapatıldı",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "MGBX Yeni Kullanıcı Hoş Geldin Paketi: Her kullanıcı en fazla alabilir",
  我已经阅读并同意: "Okudum ve kabul ediyorum",
  隐私政策: "Gizlilik Politikası",
  放弃奖励离开: "Ödülden Vazgeç ve Ayrıl",
  继续注册: "Kayda Devam Et",
  分钟: "Dakika",
  "请先勾选隐私政策!": "Lütfen önce Gizlilik Politikasını kontrol edin!",

  添加其他到自选: "Diğerlerini İzleme Listesine ekle",

  充值最高可得: "Bakiyenizi yükleyin ve 30.000 $'a kadar kazanın.",

  请输入格式正确的手机号: "Lütfen geçerli bir cep telefonu numarası girin.",

  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 土耳其



// WEBPACK FOOTER //
// ./src/lang/tr.js